import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { useStoreActions } from '../store/actions';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import cls from '../styles/Apartments.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface Type {
  [x: string]: {
    rooms: string;
    square: string;
  };
}

const apartments: Type = {
  '1': {
    rooms: '2',
    square: '100.9'
  },
  '2': {
    rooms: '3',
    square: '101.4'
  },
  '3': {
    rooms: '1',
    square: '64.6'
  },
  '4': {
    rooms: '3',
    square: '113.3'
  },
  '5': {
    rooms: '3',
    square: '133.3'
  },
  '6': {
    rooms: '1',
    square: '50.3'
  },
  '7': {
    rooms: '2',
    square: '84.7'
  },
  '8': {
    rooms: '2',
    square: '84.9'
  },
};

const ApartmentsB = () => {
  const {
    incrementSelectedFloor,
    decrementSelectedFloor,
    toggleSelectedObject,
    onHoverOverApartment,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor, selectedObject, selectedApartment } = useSnapshot(AppStore);

  return (
    <div className={cls.mainContainer}>
      <div onClick={() => goPrevPage(22)} className={cls.mobileNavigationButton}>
        <img src="./images/arrow.png" alt="Назад" />
        <p>К выбору блока</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <MdKeyboardArrowLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={incrementSelectedFloor} className={cls.arrowButton}>
              <MdKeyboardArrowRight />
            </button>
          </div>

          <div className={cls.selectionBody}>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <MdKeyboardArrowLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Блок</p>
              <p>{selectedObject}</p>
            </div>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <MdKeyboardArrowRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.imageWrapper}>
            <LazyLoadImage
              src={`./images/apartments/blockB/${selectedApartment}.png`}
              alt=""
              effect="blur"
            />
          </div>

          <div className={cls.textWrapper}>
            <p>{apartments[selectedApartment].rooms}-комнатные</p>

            <div className={cls.detailItem}>
              <div>Объект:</div>
              <div>«Da Vinchi»</div>
            </div>

            <div className={cls.detailItem}>
              <div>Площадь квартиры:</div>
              <div>{apartments[selectedApartment].square} кв.м</div>
            </div>

            <div className={cls.detailItem}>
              <div>Адрес:</div>
              <div>Бишкек, мкрн Асанбай</div>
            </div>
          </div>
        </div>
      </div>

      <div className={cls.imageContainer}>
        <div onClick={() => goPrevPage(22)} className={cls.navigationButton}>
          <img src="./images/arrow.png" alt="" />
          <p>К выбору этажа</p>
        </div>

        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b2-4">
              <path onMouseOver={() => onHoverOverApartment(1)} fill="#3292ffcc" d="m 887.85793,199.2061v 157.97799 h -21.36706v 47.961 h 38.22787v -13.84822 h 53.35157v 55.49518 h 38.64844V 420.67329 H 1109.3622V 198.34345 h -32.6591v 0.83233" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b3-1">
              <path onMouseOver={() => onHoverOverApartment(2)} fill="#3292ffcc" d="M 1109.2891,644.80469H 896.58594 V 486.37898h -62.34357 v -36.46572h 32.09747 v -38.30779h 44.92745 v -14.00154 h 44.06083v 55.55208 h 47.82438v -26.20162 h 106.1912" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b2-1">
              <path onMouseOver={() => onHoverOverApartment(3)} fill="#3292ffcc" d="m 713.06195,644.89243v -26.89634 h 6.87771v -12.96093 h -1.88888V 449.94088 h 28.94677v -5.44479 h 81.01344v 48.15846 H 890.375v 152.14397" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b3-2">
              <path onMouseOver={() => onHoverOverApartment(4)} fill="#3292ffcc" d="m 564.02814,604.87461v -31.79258 h -1.3758V 274.50781 h 1.31641v -38.85937 h 145.125V 274.375 h 2.625v 298.71295 h -2.66743v 31.87299 h -2.19195v 7.04687 H 564.02814" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b3-3">
              <path onMouseOver={() => onHoverOverApartment(5)} fill="#3292ffcc" d="m 408.658,202.65238v 442.2734 h 151.24825v -26.94207 h -4.5625v -32.53059 h 1.17138v -311.0625 h -1.06201v -44.74218 h 4.59375v -27.10938" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b1-1">
              <path onMouseOver={() => onHoverOverApartment(6)} fill="#3292ffcc" d="M 256.09971,644.94215V 496.66406 h 56.98287v -35.29898 h 31.57367v 5.30679 h 57.76562v 178.15625" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b2-2">
              <path onMouseOver={() => onHoverOverApartment(7)} fill="#3292ffcc" d="M 65.171875,611.89062V 426.92187 h 74.664015v 27.00391 h 54.26492V 399.7363 H 231.699v 27.19599 h 45.70725v 34.42174 h 26.03125v 29.10691 h -12.83203v -2.6836 h -31.7381v -2.13309 h -12.79706 v 8.10411h -12.28313 v 29.49383h 15.94857 v 49.74218h -1.642 v 44.97724h 1.6641 v 27.08526l -151.3516,10e-6 V 612" />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/da-vinci/b2-2">
              <path onMouseOver={() => onHoverOverApartment(8)} fill="#3292ffcc" d="m 65.398437,235.6875h 28.160629 v -8.03779h 4.828213 V 202.41484H 249.76562 v 27.24141H 248 v 44.5686h 1.69708 v 85.71265h 41.21107 v -2.97011h 13.16986 v 28.10292h -26.62699 v 35.61403 h -39.4354V 393.3171 h -53.32817v 54.47196 H 146.10937V 420.75781 H 65.086969" />
            </a>
          </svg>

          <LazyLoadImage
            src="./images/floors/blockB.png"
            alt=""
            effect="blur"
          />
        </div>
      </div>
    </div>
  );
};

export default ApartmentsB;
